<template>
  <v-app-bar :style="'max-width:100%'" color="third" dark app>
    <!-- Logo / título -->
    <v-img class="logo p-0 ms-0 " :src="logohorizontal" alt="Logo" max-width="200" @click="$router.push('/')"
      contain></v-img>

    <v-spacer></v-spacer>
    <!-- Tabs para desktop -->
    <v-tabs v-if="!isMobile" v-model="tab" slider-color="transparent">
      <v-tab v-for="(item, i) in castellano? itemsCAS:items" :key="i" v-bind="item.link.startsWith('http')
        ? { href: item.link, target: '_blank', rel: 'noopener noreferrer' }
        : { to: item.link }" :style="{ fontWeight: tab === i ? '1000' : '200' }" 
        :class="{ 'language-tab': i === (castellano ? itemsCAS.length : items.length) - 1 }"
        >

    {{ item.title }}
      </v-tab>
    </v-tabs>


    <!-- MOBILE -->
    <v-menu v-else>
      <template v-slot:activator="{ props }">
        <v-btn icon="mdi-menu" text v-bind="props"></v-btn>
      </template>

      <v-list class="bg-third custom-menu">
        <v-list-item v-for="(item, i) in castellano?itemsCAS:items" :key="i" :value="i" v-bind="item.link.startsWith('http')
          ? { href: item.link, target: '_blank', rel: 'noopener noreferrer' }
          : { to: item.link }"
          :class=" i === (castellano ? itemsCAS.length : items.length) - 1 ?'language-menu-item':'menu-item'"
          >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

  </v-app-bar>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRoute } from 'vue-router'

import logohorizontal from '@/assets/logos/logohorizontal.svg'

const tab = ref(null)
const items = ref([
  { title: 'Home', link: '/' },
  { title: 'Bio', link: '/bio' },
  { title: 'Tour', link: '/tour' },
  { title: 'Musika', link: '/musika' },
  { title: 'Denda', link: 'https://latrastienda.pro/collections/burutik' },
  { title: 'Kontaktua', link: '/kontaktua' },
  { title: 'CAS', link: '/cas' },
])
const itemsCAS = ref([
  { title: 'Home', link: '/cas' },
  { title: 'Bio', link: '/cas/bio' },
  { title: 'Tour', link: '/cas/tour' },
  { title: 'Música', link: '/cas/musika' },
  { title: 'Tienda', link: 'https://latrastienda.pro/collections/burutik'},
  { title: 'Contacto', link: '/cas/kontaktua' },
  { title: 'EUS', link: '/' },
])
const route = useRoute()
const castellano = computed(() => route.path.startsWith('/cas'))

const isMobile = ref(false)
const checkMobile = () => {
  isMobile.value = window.innerWidth < 768 // breakpoint móvil
}

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})
const menuOpen = ref(false)
const toggleMenu = () => menuOpen.value = !menuOpen.value
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: #222;
  color: white; */
  padding: 0.5rem 1rem;
}

.logo {
  cursor: pointer;
}
.language-tab {
  position: relative; /* necesario para el ::before absoluto */
  padding-left: 12px; /* espacio para que no quede sobre el texto */
}
.language-tab::before {
  content: '';
  position: absolute;
  left: 0;            /* pegado al inicio de la tab */
  top: 50%;           /* vertical centrado */
  transform: translateY(-50%); /* centrado exacto verticalmente */
  width: 2.5px;       /* grosor de la línea */
  height: 45%;        /* altura de la línea */
  background-color: rgb(193, 183, 162);
  border-radius: 1px; /* opcional para bordes suaves */
}

.language-menu-item {
  position: relative;
  text-align: center;
  padding-top: 8px; /* espacio para que no quede pegado al borde superior */
}
.menu-item {
   text-align: center;
}


.language-menu-item::before {
  content: '';
  position: absolute;
  top: 0;               /* al inicio del item */
  left: 30%;              /* inicio horizontal */
  width: 40%;          /* ancho completo, o puedes poner 70% para centrarlo */
  height: 1.5px;        /* grosor */
  background-color: rgb(193, 183, 162);
  border-radius: 1px;   /* opcional, para un estilo más “suave” */
}
.custom-menu {
  min-width: 250px;
}

.navbar .menu-icon {
  font-size: 2rem;
  cursor: pointer;
  display: none;
}

.navbar ul {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

.navbar ul li {
  margin-left: 1rem;
}

.navbar ul li a {
  color: white;
  text-decoration: none;
}

@media (max-width: 768px) {
  .navbar .menu-icon {
    display: block;
  }

  .navbar ul {
    position: absolute;
    top: 60px;
    right: 0;
    background: #222;
    flex-direction: column;
    width: 200px;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
  }

  .navbar ul.open {
    transform: translateX(0);
  }

  .navbar ul li {
    margin: 1rem;
  }

  ::v-deep(.v-tab.v-tab--active) {
    font-weight: 700;
  }
  .language-item {
  border-top: 1px solid gray;
  /* margin-top: 4px; */
  padding-top: 4px;
}
}
</style>
